function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { concat, uint64be } from '../lib/buffer_utils.js';
import checkIvLength from '../lib/check_iv_length.js';
import checkCekLength from './check_cek_length.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import { checkEncCryptoKey } from '../lib/crypto_key.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import generateIv from '../lib/iv.js';
import { JOSENotSupported } from '../util/errors.js';
import { types } from './is_key_like.js';
function cbcEncrypt(_x, _x2, _x3, _x4, _x5) {
  return _cbcEncrypt.apply(this, arguments);
}
function _cbcEncrypt() {
  _cbcEncrypt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(enc, plaintext, cek, iv, aad) {
    var keySize, encKey, macKey, ciphertext, macData, tag, _t2, _t3, _t4, _t5;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (cek instanceof Uint8Array) {
            _context2.n = 1;
            break;
          }
          throw new TypeError(invalidKeyInput(cek, 'Uint8Array'));
        case 1:
          keySize = parseInt(enc.slice(1, 4), 10);
          _context2.n = 2;
          return crypto.subtle.importKey('raw', cek.subarray(keySize >> 3), 'AES-CBC', false, ['encrypt']);
        case 2:
          encKey = _context2.v;
          _context2.n = 3;
          return crypto.subtle.importKey('raw', cek.subarray(0, keySize >> 3), {
            hash: "SHA-".concat(keySize << 1),
            name: 'HMAC'
          }, false, ['sign']);
        case 3:
          macKey = _context2.v;
          _t2 = Uint8Array;
          _context2.n = 4;
          return crypto.subtle.encrypt({
            iv: iv,
            name: 'AES-CBC'
          }, encKey, plaintext);
        case 4:
          _t3 = _context2.v;
          ciphertext = new _t2(_t3);
          macData = concat(aad, iv, ciphertext, uint64be(aad.length << 3));
          _t4 = Uint8Array;
          _context2.n = 5;
          return crypto.subtle.sign('HMAC', macKey, macData);
        case 5:
          _t5 = _context2.v.slice(0, keySize >> 3);
          tag = new _t4(_t5);
          return _context2.a(2, {
            ciphertext: ciphertext,
            tag: tag,
            iv: iv
          });
      }
    }, _callee2);
  }));
  return _cbcEncrypt.apply(this, arguments);
}
function gcmEncrypt(_x6, _x7, _x8, _x9, _x0) {
  return _gcmEncrypt.apply(this, arguments);
}
function _gcmEncrypt() {
  _gcmEncrypt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(enc, plaintext, cek, iv, aad) {
    var encKey, encrypted, tag, ciphertext, _t6, _t7;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          if (!(cek instanceof Uint8Array)) {
            _context3.n = 2;
            break;
          }
          _context3.n = 1;
          return crypto.subtle.importKey('raw', cek, 'AES-GCM', false, ['encrypt']);
        case 1:
          encKey = _context3.v;
          _context3.n = 3;
          break;
        case 2:
          checkEncCryptoKey(cek, enc, 'encrypt');
          encKey = cek;
        case 3:
          _t6 = Uint8Array;
          _context3.n = 4;
          return crypto.subtle.encrypt({
            additionalData: aad,
            iv: iv,
            name: 'AES-GCM',
            tagLength: 128
          }, encKey, plaintext);
        case 4:
          _t7 = _context3.v;
          encrypted = new _t6(_t7);
          tag = encrypted.slice(-16);
          ciphertext = encrypted.slice(0, -16);
          return _context3.a(2, {
            ciphertext: ciphertext,
            tag: tag,
            iv: iv
          });
      }
    }, _callee3);
  }));
  return _gcmEncrypt.apply(this, arguments);
}
var encrypt = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(enc, plaintext, cek, iv, aad) {
    var _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(!isCryptoKey(cek) && !(cek instanceof Uint8Array))) {
            _context.n = 1;
            break;
          }
          throw new TypeError(invalidKeyInput.apply(void 0, [cek].concat(_toConsumableArray(types), ['Uint8Array'])));
        case 1:
          if (iv) {
            checkIvLength(enc, iv);
          } else {
            iv = generateIv(enc);
          }
          _t = enc;
          _context.n = _t === 'A128CBC-HS256' ? 2 : _t === 'A192CBC-HS384' ? 2 : _t === 'A256CBC-HS512' ? 2 : _t === 'A128GCM' ? 3 : _t === 'A192GCM' ? 3 : _t === 'A256GCM' ? 3 : 4;
          break;
        case 2:
          if (cek instanceof Uint8Array) {
            checkCekLength(cek, parseInt(enc.slice(-3), 10));
          }
          return _context.a(2, cbcEncrypt(enc, plaintext, cek, iv, aad));
        case 3:
          if (cek instanceof Uint8Array) {
            checkCekLength(cek, parseInt(enc.slice(1, 4), 10));
          }
          return _context.a(2, gcmEncrypt(enc, plaintext, cek, iv, aad));
        case 4:
          throw new JOSENotSupported('Unsupported JWE Content Encryption Algorithm');
        case 5:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function encrypt(_x1, _x10, _x11, _x12, _x13) {
    return _ref.apply(this, arguments);
  };
}();
export default encrypt;